// İfade "AI ile Özetle" — Gemini'ye gönderilen talimat.

const VARSAYILAN_OZET_TALIMATI =
  'Lütfen aşağıdaki metin içerisindeki olayı kısa cümleler kullanarak özetle, özeti mümkün olduğunca uzun tut, özette tarih ve saat bilgileri dataylı olarak yer alsın:';

export const buildOzetPrompt = ({ content, customPrompt = '' }) =>
  `${customPrompt || VARSAYILAN_OZET_TALIMATI}\n\n${content}`;
